import { render, staticRenderFns } from "./NotificationFacturalNavixy.vue?vue&type=template&id=8cf26d8e&"
import script from "./NotificationFacturalNavixy.vue?vue&type=script&lang=js&"
export * from "./NotificationFacturalNavixy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports